import { apiEmpleo } from "../../util/ApiEmpleo";

export type TCreateContactRequest = {
  id: string;
  Business_Country?: string;
  First_Name: string;
  Last_Name: string;
  Email?: string;
  Phone?: string;
  Parentesco?: string;
};

const apiCreateContact = async (contact: TCreateContactRequest) => {
  let res = await apiEmpleo.post(`contacts`, contact, {
    headers: {
      "Content-Type": "application/ld+json",
    },
  });

  return res;
};

export { apiCreateContact };
